<div class="badge" [ngClass]="{'active': isActive, 'valid': isValid}">{{bageNumber ? bageNumber: bageName  }}</div>
<div class="text">{{text}}</div>